/**
 * Componente Home que permite renderizar la pantalla inicial de la aplicación
 */

import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Layout, Menu, Button, Tooltip, Space, Modal } from 'antd';
import { UserOutlined, LogoutOutlined, AppstoreOutlined, SearchOutlined, SolutionOutlined, TagsOutlined, FolderOutlined, AuditOutlined, QuestionCircleFilled, DeleteOutlined, SafetyOutlined, BellOutlined } from '@ant-design/icons';

import '../styles/home.scss';
/**
 * 


import project from '../../../../package';

const { name, version } = project;
 */
import { logout } from '../../actions/auth/logout';
import { SecuritySettings } from '../mfa/security_settings';
import { Documents } from '../documents';
import { Users } from '../users';
import { Customers } from '../customers';
import { References } from '../references';
import { Folders } from '../folders';
import { Search } from '../search';
import { Audit } from '../audit';
import { Trash } from '../trash';
import { Tokens } from '../tokens';
import { DeletionRequests, usePendingRequestCount } from '../deletion_requests';
import { isSupervisor } from '../../lib/closed_folder_perms';
import '../styles/home.scss';
import '../styles/acces.scss';
const { Header, Content, Footer } = Layout;

const LogoCompany = "https://firebasestorage.googleapis.com/v0/b/gestor-documental-67434.appspot.com/o/logo%20cr.png?alt=media&token=47b447f5-7845-4168-87dd-7af7c3644b1d";

/**
 * Exporta el componente Home
 */
export const Home = () => {

  // Funcion que permite ejecutar todas las acciones del estado de redux
  const dispatch = useDispatch();
  // Selecciona los reductores
  const roles = useSelector(state => state.get('roles').get('roles').roles);
  const user = useSelector(state => state.get('authenticate').get('login').user);

  // Manejo de los estados del componente
  const [content, setContent] = useState('documents');
  // Modal de seguridad (verificación en 2 pasos)
  const [securityVisible, setSecurityVisible] = useState(false);
  // Contador de solicitudes pendientes para supervisoras y root.
  const pendingRequests = usePendingRequestCount(isSupervisor(roles), roles);

  const componets = {
    documents: <Documents />,
    users: <Users />,
    customers: <Customers />,
    references: <References />,
    folders: <Folders />,
    search: <Search />,
    audit: <Audit />,
    trash: <Trash />,
    tokens: <Tokens />,
    requests: <DeletionRequests />,
  };

  /**
   * Metodo que se ejcuta cuando se hace clic en las opciones del menu
   * Se encarga de cargar el componente correspondiente
   * @param {object} evt 
   */
  const onMenuClick = evt => setContent(evt.key);

  /**
   * Metodo que permite cerrar la sesión de un usuario.
   *
   * Confirmación con Modal antes de ejecutar signOut() para prevenir
   * clicks accidentales — Cloud Logging confirmó que el botón rojo del
   * Header recibía clicks no intencionados (Object.onClick disparado por
   * el handler real), aunque el cliente reportaba "se desloguea solo".
   */
  const onLogout = () => {
    Modal.confirm({
      title: 'Cerrar sesión',
      content: '¿Está seguro de que desea cerrar la sesión?',
      okText: 'Cerrar sesión',
      okType: 'danger',
      cancelText: 'Cancelar',
      onOk: () => dispatch(logout()),
    });
  };

  // ELIMINADO el useEffect de auto-logout.
  //
  // Bug histórico: el código original `if (!roles?.documents) dispatch(logout())`
  // se disparaba en estados transitorios. Cualquier refresh de `onAuthStateChanged`
  // (custom claims, refresh de token, re-validación) pasaba por ROLES.GETTING_ROLES,
  // dejando `roles.documents` temporalmente undefined. El efecto se ejecutaba
  // antes de que GETTED_ROLES llegara, y deslogueaba al usuario en medio de
  // la sesión. Más visible en el rol "cliente" al seleccionar empresa en
  // consultas.
  //
  // El guard de auth real ya vive en `src/application/navigation/index.js`:
  //  - Si roles() falla con error transitorio → mantiene LOGGEDIN y reintenta
  //  - Si falla con error permanente → dispatch AUTH.LOGGINGIN → muestra Login
  // Duplicar esa lógica aquí solo introducía falsos positivos. Si por alguna
  // razón el state.roles queda inconsistente sin un user válido, el flujo
  // de navigation se encarga.

  /**
   * Metodo que renderiza el componente
   */
  return (
    <Layout className="layout-app" >
      {/*
        Header con flexbox responsivo. ANTES usaba `float: left/right` con un
        span "Daysi" de `font-size: 8vh` (~73px en móviles) que desbordaba en
        pantallas angostas, posicionando el botón de logout encima del
        selector del cliente. Resultado: el cliente tocaba "Seleccionar
        empresa" pero su dedo pegaba en el botón rojo de logout invisible y
        la sesión se cerraba. Solo se reproducía en rol cliente porque ese
        rol tiene menú corto (2 items) y el desbordamiento caía justo sobre
        el selector visible.
      */}
      <Header style={{
        padding: '0 20px',
        color: '#1890ff',
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        height: 'auto',
        minHeight: 64,
        flexWrap: 'wrap',
        gap: '10px',
      }} >
        <div style={{ display: 'flex', alignItems: 'center' }} >
          <Space>
            <Button type="primary" ghost icon={<UserOutlined />} > {user?.displayName} </Button>
            <Button type="primary" ghost icon={<QuestionCircleFilled />}
              onClick={() => window.open('http://crconsultorescolombia.com/manual/Manual-Daysi.html', "_blank")}
            > Manual </Button>
            <Tooltip placement="bottom" title="Verificación en 2 pasos" >
              <Button type="primary" ghost icon={<SafetyOutlined />}
                onClick={() => setSecurityVisible(true)}
              > Seguridad </Button>
            </Tooltip>
            <img alt="Logo Company" src={LogoCompany} style={{ width: 80, height: 50, marginRight: 20, marginLeft: 20 }} />
          </Space>
        </div>
        <div style={{ display: 'flex', alignItems: 'center', marginLeft: 'auto', flexWrap: 'wrap', gap: '10px' }} >
          <span style={{ marginRight: 20, fontFamily: 'Cookie', fontSize: '32px', color: '#E70810', textAlign: 'center', display: 'inline-block', lineHeight: 'normal' }}> Daysi </span>
          <Tooltip placement="left" title='Cerrar sesion' >
            <Button style={{ borderColor: '#800000', backgroundColor: '#800000' }} shape="circle" onClick={onLogout} >
              <LogoutOutlined style={{ fontSize: '20px', backgroundColor: '#800000', color: '#00000', }} />
            </Button>
          </Tooltip>
        </div>
      </Header>
      <SecuritySettings visible={securityVisible} setVisible={setSecurityVisible} />
      <Layout>
        <Menu onClick={onMenuClick} defaultSelectedKeys={['documents']} mode="horizontal" theme="dark" >
          {roles?.documents?.read ? <Menu.Item key="documents" > <AppstoreOutlined /> Documentos </Menu.Item> : null}
          {roles?.documents?.read ? <Menu.Item key="search" > <SearchOutlined /> Consultas </Menu.Item> : null}
          {roles?.users?.read ? <Menu.Item key="users" > <UserOutlined /> Usuarios </Menu.Item> : null}
          {roles?.customers?.read ? <Menu.Item key="customers" > <SolutionOutlined /> Clientes </Menu.Item> : null}
          {roles?.references?.read ? <Menu.Item key="references" > <TagsOutlined /> Referencias </Menu.Item> : null}
          {roles?.folders?.templates?.read ? <Menu.Item key="folders" > <FolderOutlined /> Carpetas </Menu.Item> : null}
          {roles?.documents?.read && roles?.documents?.level === "all" ? <Menu.Item key="audit" > <AuditOutlined /> Log de auditoria </Menu.Item> : null}
          {roles?.documents?.delete ? <Menu.Item key="trash" > <DeleteOutlined /> Papelera </Menu.Item> : null}
          {isSupervisor(roles) ? <Menu.Item key="requests" > <BellOutlined /> Solicitudes{pendingRequests ? ` (${pendingRequests})` : ''} </Menu.Item> : null}
          {roles?.documents?.root === true ? <Menu.Item key="tokens" > <SafetyOutlined /> Tokens </Menu.Item> : null}
        </Menu>
        <Content style={{ margin: '24px 16px 0' }} >
          <div className="amarillo" style={{ padding: 24, background: '#fff', minHeight: 360 }} > {componets[content]} </div>
          <Footer style={{ textAlign: 'center' }} >
            {` Versión `} - Para soporte escribir a:
            <br />
            Email:
            <a href={`mailto:rreyes@crconsultorescolombia.com?Subject=Cr Consultores`} target="_top" >
              {` rreyes@crconsultorescolombia.com`}
            </a> - Ramiro Reyes Amaya.
          </Footer>
          {/* <Footer   style = {{ textAlign: 'center' }} >
              ©2018 Created by <a href = { homepage } target = "_blank" > { author.name } </a> - { `${ _.capitalize( name ) } Versión ${ version }` }
              <br />
              Email:
                <a href = { `mailto:${ author.email }?Subject=Contacto` } target = "_top" >
                  { ` ${ author.email } ` }
                </a>
            </Footer> */}
        </Content>
      </Layout>
    </Layout>
  );
};